// extracted by mini-css-extract-plugin
export default {"card_text_only":"card_text_only_card_text_only__2e+Kg"};